export default __webpack_public_path__ + "static/media/Warning.70ea8286.svg";